import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import SiteFooter from '../components/Footer';
import API_BASE_URL, { buildApiHeaders } from '../utils/config';
import '../App.css';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const form = new URLSearchParams();
      form.append('username', email);
      form.append('password', password);
      form.append('org', 'neutralfit');
      const res = await fetch(`${API_BASE_URL}/login`, {
        method: 'POST',
        headers: buildApiHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' }),
        body: form.toString(),
      });
      if (res.ok) {
        const data = await res.json();
        localStorage.setItem('token', data.access_token);
        localStorage.setItem('user', JSON.stringify(data.user));
        navigate('/club-fitting');
      } else {
        setError('Login failed.');
      }
    } catch (err) {
      setError('Login failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="nf-form-container">
      <button className="nf-home-btn" type="button" onClick={() => navigate('/')} aria-label="Close">&#10005;</button>
      <h2 className="nf-form-title">Login</h2>
      
      {/* 1. Login Button (Form) - First */}
      <form className="nf-form" onSubmit={handleSubmit}>
        <input className="nf-input" name="email" type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} autoComplete="email" required />
        <input className="nf-input" name="password" type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} autoComplete="current-password" required />
        <button className="nf-btn nf-btn-primary nf-form-btn" type="submit" disabled={loading}>
          {loading ? 'Logging in...' : 'Login'}
        </button>
      </form>
      
      {/* Error message right after Login button */}
      {error && <div className="nf-error" style={{ marginTop: '1rem' }}>{error}</div>}
  
      <div className="nf-info-section" style={{ width: '90%', textAlign: 'center' }}>
        <br />
        No account? <Link to="/signup" className="nf-link nf-forgot-link">Create one</Link>
      </div>

      <div className="nf-info-section" style={{ width: '90%', textAlign: 'center' }}>
        <br />
        Forgot your password? <br />Click <Link to="/forgot-password" className="nf-link nf-forgot-link">Reset Password</Link>
      </div>

      <SiteFooter style={{ marginTop: '30px' }} />
    </div>
  );
};

export default Login;
